<script setup>
import AppLayout from '@/layouts/AppLayout.vue';
import HomeFeatureSection1 from '@components/home/FeatureSection1.vue'
import HomeFeatureSection2 from '@components/home/FeatureSection2.vue'
import HomeFeatureSection3 from '@components/home/FeatureSection3.vue'
import HomeFeatureSection4 from '@components/home/FeatureSection4.vue'
import HomeHeadingSection from '@components/home/HeadingSection.vue'
import SeparatorBorder from '@components/SeparatorBorder.vue'
</script>

<template>
  <Suspense>
    <AppLayout title="Home">
      <div class="px-6 py-12 mb-16 bg-white sm:py-32 lg:px-8 isolate rounded-lg shadow">
        <HomeHeadingSection/>
        <SeparatorBorder/>
        <HomeFeatureSection1/>
        <SeparatorBorder/>
        <HomeFeatureSection2/>
        <SeparatorBorder/>
        <HomeFeatureSection3/>
        <SeparatorBorder/>
        <HomeFeatureSection4/>
      </div>
    </AppLayout>
  </Suspense>
</template>
